<template>
  <div
    class="container page"
    v-loading="loading"
  >
    <el-scrollbar
      wrap-class="m-scroll-wrap"
      v-show="arrParts && arrParts.length > 0"
      ref="drawCtn"
    >
      <div
        class="m-main-container"
        :style="containerStyle"
      >
        <div
          class="m-data-view-header"
          v-if="pageInfo.isDisplayBoardName===0"
        >
          <div class="m-data-view-tt">
            {{ pageInfo.title }}
          </div>
        </div>
        <div
          v-for="(part, i) in arrParts"
          class="m-parts-card"
          :style="
            `left:${part.xPos}px;top:${part.yPos}px;transform:rotate(${
              part.type === 'line' || part.type === 'line2' ? part.angle : 0
            }deg);width:${part.width && part.resizable ? part.width + 'px' : 'auto'};height:${part.height && part.resizable ? part.height + 'px': 'auto'};`
          "
          :key="i"
        >
          <div
            v-if="part.type === 'line'"
            class="m-line"
            :style="`width:${part.width}px;color:#fff;`"
          >
            <div class="u-line-start"></div>
            <div class="u-line-repeat"></div>
            <div class="u-line-end"></div>
          </div>
          <div
            v-else-if="part.type === 'line2'"
            class="m-line"
            :style="`width:${part.width}px;color:#fff;`"
          >
            <div class="u-line-start"></div>
            <div class="u-line-repeat"></div>
            <div class="u-line-end2"></div>
          </div>
          <component
            :is="part.mode"
            :width="part.width"
            :height="part.height"
            v-bind="part.option"
            v-else
          ></component>
        </div>
      </div>
    </el-scrollbar>
    <div
      class="m-no-data"
      v-show="showNoData"
    >
      <div class="inner">
        <img src="../../assets/images/no_data.png" />
        <span>
          {{ $t("common.no_data") }}
        </span>
      </div>
    </div>
    <mps-service
      :componentSet="['portal.bs.displayboard']"
      @message-get="onMessageGet"
    ></mps-service>
  </div>
</template>

<script>
import API from 'api/api'
import axios from 'axios'
import mpsService from 'components/mps-service/messager'
import { getQueryString } from 'utils/mixin'
export default {
  name: 'data-view-home',
  data () {
    return {
      arrParts: [],
      pageInfo: {
        backgroundImageUrl: '',
        title: '',
        isDisplayBoardName: 0,
        width: 0,
        height: 0
      },
      loading: true
    }
  },
  components: { mpsService },
  computed: {
    showNoData () {
      return (!this.arrParts || this.arrParts.length === 0) && !this.loading
    },
    containerStyle () {
      return {
        'background-image': `url('${this.pageInfo.backgroundImageUrl}')`,
        'width': `${this.pageInfo.width}px`,
        'height': `${this.pageInfo.height}px`
      }
    }
  },
  mounted () {
    this.getDataViewKey()
    this._keepAlive()
  },
  methods: {
    // websocket消息推送
    onMessageGet (data) {
      let params = {
        sourceId: 'portal',
        destId: data.widgetId,
        msgType: 'displayboard',
        data: data.data
      }
      this.$root.$emit(`${data.widgetId}_displayboard`, params)
    },
    // 通过URL地址，判断是自定义首页入口进来的还是门户管理进来的
    getDataViewKey () {
      let key = this.getQueryString('key')
      if (key) {
        this.getDataViewDetail(key)
      }
    },
    getDataViewDetail (key) {
      API.dataView.getDataViewDetail({ boardId: key }).then(async res => {
        this.pageInfo.backgroundImageUrl = res.data.backgroundImageUrl
        this.pageInfo.title = res.data.title
        this.pageInfo.isDisplayBoardName = res.data.isDisplayBoardName
        this.pageInfo.width = res.data.width
        this.pageInfo.height = res.data.height
        await res.data.widgetList.forEach(widget => {
          let pos = {
            xPos: widget.xPos,
            yPos: widget.yPos
          }
          widget.type = widget.type === 1 ? 'line' : widget.type === 2 ? 'line2' : 0
          // 根据后端返回数据来设置宽高
          widget.resizable = widget.widgetHeight && widget.widgetWidth
          if (widget.widgetHeight) {
            widget.height = widget.widgetHeight
          }
          if (widget.widgetWidth) {
            widget.width = widget.widgetWidth
          }
          widget.option = widget.option ? JSON.parse(widget.option) : {}
          this.handlePushWidget(widget, pos)
        })
      }).catch(() => {
        this.loading = false
      })
    },
    // 将拖拽的部件数据置入编辑区内
    async handlePushWidget (widget, pos) {
      let part = JSON.parse(JSON.stringify(widget))
      part['xPos'] = pos.xPos
      part['yPos'] = pos.yPos
      if (widget.type !== 'line' && widget.type !== 'line2') {
        let Fn = Function
        let res = await axios.get(part.url)
        let mode = new Fn(`return ${res.data}`)()
        part['mode'] = mode.__esModule ? mode.default : mode
      }
      this.arrParts.push(part)
      this.$nextTick(() => {
        this.loading = false
      })
    },
    // session保活
    _keepAlive () {
      setInterval(() => {
        API.common.keepAlive().catch(err => {
          this.$message.error(err.msg)
        })
      }, 1200000)
    }
  },
  mixins: [getQueryString]
}
</script>

<style scoped lang="scss" rel="stylesheet/less">
@import "../../assets/styles/func.scss";
.container.page {
  position: relative;
  width: 100%;
  height: 100%;
  .m-no-data {
    position: relative;
    width: 100%;
    height: 100%;
    background: #fff;
    .inner {
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -150px;
      margin-top: -100px;
      width: 300px;
      height: 200px;
      font-size: 14px;
      text-align: center;
      color: rgba(0, 0, 0, 0.4);
      img {
        height: 160px;
      }
      span {
        display: block;
        line-height: 40px;
      }
    }
  }
  ::v-deep .m-scroll-wrap {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    .m-main-container {
      position: relative;
      // width: vw(1920);
      // height: vw(1080);
      .m-line {
        width: 300px;
        height: 10px;
        .u-line-start {
          float: left;
          width: 61px;
          height: 10px;
          background-image: url("../../assets/images/line_start.png");
          background-position: center;
          background-repeat: no-repeat;
        }
        .u-line-repeat {
          float: left;
          width: calc(100% - 119px);
          height: 10px;
          background-image: url("../../assets/images/line_repeat.png");
          background-position: center;
          background-repeat: repeat-x;
        }
        .u-line-end {
          float: left;
          width: 58px;
          height: 10px;
          background-image: url("../../assets/images/line_end.png");
          background-position: center;
          background-repeat: no-repeat;
        }
        .u-line-end2 {
          float: left;
          width: 58px;
          height: 10px;
          background-image: url("../../assets/images/line_end2.png");
          background-position: center;
          background-repeat: no-repeat;
        }
      }
      .m-parts-card {
        position: absolute;
      }
      .m-data-view-header {
        position: absolute;
        left: 50%;
        margin-left: -755px;
        top: 0;
        width: 1511px;
        height: 101px;
        background-image: url("../../assets/images/kanban-header.png");
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        .m-data-view-tt {
          position: absolute;
          left: 50%;
          margin-left: -343px;
          width: 686px;
          height: 74px;
          line-height: 74px;
          letter-spacing: 2px;
          text-align: center;
          font-size: 32px;
          color: #c7dfff;
          font-weight: bold;
          overflow: hidden;
          user-select: none;
        }
      }
    }
  }
}
</style>
